/** Paying someone: cut the agreed advance recovery first, hand over the rest. All in paise to avoid float drift. */

const paise = (v: string | number | null | undefined): number => {
  const n = typeof v === "number" ? v : Number(String(v ?? "").trim() || "0");
  return isFinite(n) ? Math.round(n * 100) : NaN;
};

export const rupeeString = (p: number): string => (p / 100).toFixed(2);

export type PayPlan = { cut: string; handOver: string; error?: string };

/** Check a payout: the cut can't exceed the advance owed or wages due; cut + hand-over can't exceed wages due. */
export const checkPayout = (wagesDue: string, advanceOwed: string, cut: string, handOver: string): string | undefined => {
  const due = paise(wagesDue);
  const owed = paise(advanceOwed);
  const c = paise(cut);
  const h = paise(handOver);
  if (isNaN(c) || isNaN(h) || c < 0 || h < 0) return "Enter amounts as numbers";
  if (c === 0 && h === 0) return "Enter an amount";
  if (c > owed) return `Cut at most ${rupeeString(owed)} — that's all the advance owed`;
  if (c + h > due) return `Cut + paid can't be more than the wages due (${rupeeString(due)})`;
  return undefined;
};

/** Start from: cut the suggested recovery, hand over the rest of the wages due. */
export const defaultPayout = (wagesDue: string, suggestedRecovery: string): PayPlan => {
  const due = Math.max(0, paise(wagesDue) || 0);
  const cut = Math.min(due, Math.max(0, paise(suggestedRecovery) || 0));
  return { cut: rupeeString(cut), handOver: rupeeString(due - cut) };
};

export const KIND_LABEL: Record<string, string> = {
  PAYMENT: "Paid",
  ADVANCE: "Advance given",
  RECOVERY: "Cut for advance",
  ADJUSTMENT: "Adjustment",
  OPENING: "Opening balance",
};

export const METHODS = [
  { key: "CASH", label: "Cash" },
  { key: "UPI", label: "UPI" },
  { key: "BANK", label: "Bank" },
];
